import React from 'react'
import { faClockThreeThirtySolid, FaIcon } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import Radio from '@/modules/drivers/shared/Radio'
import { useCertificateStore } from '@/modules/drivers/stores/certificateStore'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { AttestationType } from '@/app/constants/attestationType'
import { getAttestationName } from '@/app/services/attestation/attestationNameResolver'

import { getAttestationType, getAttestationTypeNumber } from '@/app/services/attestation/attestationTypeResolver'

const CertificateBasedOn = () => {
  const { t } = useLocalize()
  const { data, setData } = useCertificateStore()

  const attestationTypeOptions = Object.values(AttestationType).map((ct) => ({
    value: ct,
    label: getAttestationName(ct, t),
  }))

  // Backend (AttestationCreator.ProduceAttestations) only honors
  // attestationTypeBasedOnDayType when the type is Rest (4). Force the
  // toggle off and disable it for any other type so the user can't pick
  // an option that the server will silently ignore.
  const dayTypeBasedAvailable = data?.attestationType === 4
  React.useEffect(() => {
    if (!dayTypeBasedAvailable && data?.attestationTypeBasedOnDayType) {
      setData({ ...data, attestationTypeBasedOnDayType: false })
    }
  }, [dayTypeBasedAvailable])

  return (
    <div className="tw-flex tw-gap-4">
      <div className="tw-w-full tw-max-w-[200px] tw-space-y-2">
        <div className="tw-jusit tw-flex tw-flex-1 tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
          <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
          <p className="tw-text-sm tw-font-semibold tw-text-content-base">
            Generuj na podstawie
          </p>
        </div>
      </div>
      <div className="tw-space-y-2 tw-w-full">
        <div className="tw-flex tw-items-center tw-gap-3">
          <div
            className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2"
            onClick={() =>
              setData({ ...data, attestationTypeBasedOnDayType: false })
            }
          >
            <Radio
              onClick={() =>
                setData({ ...data, attestationTypeBasedOnDayType: false })
              }
              checked={data?.attestationTypeBasedOnDayType === false}
            />
            <p className="tw-text-sm tw-text-content-base">
              Wyboru użytkownika
            </p>
          </div>
          <div
            className={`tw-flex tw-items-center tw-gap-2 ${dayTypeBasedAvailable ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed tw-opacity-50'}`}
            onClick={() =>
              dayTypeBasedAvailable &&
              setData({ ...data, attestationTypeBasedOnDayType: true })
            }
            title={
              dayTypeBasedAvailable
                ? undefined
                : 'Dostępne tylko dla zaświadczenia o odpoczynku'
            }
          >
            <Radio
              onClick={() =>
                dayTypeBasedAvailable &&
                setData({ ...data, attestationTypeBasedOnDayType: true })
              }
              checked={data?.attestationTypeBasedOnDayType === true}
            />
            <p className="tw-text-sm tw-text-content-base">
              Typu dnia w kalendarzu
            </p>
          </div>
        </div>
        <FieldsetSelect
          required
          label={'Typ zaświadczenia '}
          placeholder={t('common.select')}
          value={AttestationType[getAttestationType(data?.attestationType)] ?? ''}
          name="type"
          onChange={(e) => {
            setData({
              ...data,
              attestationType: getAttestationTypeNumber(e.target.value as AttestationType)
            })
          }}
          options={attestationTypeOptions}
        />
      </div>
    </div>
  )
}

export default CertificateBasedOn
